import Avatar from "./Avatar";
import avatarUserTypes from "./userTypes";

export { Avatar as default, avatarUserTypes };
